module.exports = __webpack_public_path__ + "img/MX-A018030B-AS.46acd4fb.png";